const { apiPost } = require('./apiClient');
const { getActivityPingIntervalMs } = require('./userRights');

const STORAGE_KEY = 'lastActivityPingAt';

function recordUserActivityIfNeeded() {
    const minIntervalMs = getActivityPingIntervalMs();
    const lastPingAt = localStorage.getItem(STORAGE_KEY);
    if (lastPingAt && Date.now() - parseInt(lastPingAt, 10) < minIntervalMs) {
        return Promise.resolve();
    }

    return apiPost('user/activity', {})
        .then(() => {
            localStorage.setItem(STORAGE_KEY, Date.now().toString());
        })
        .catch(() => {});
}

module.exports = {
    recordUserActivityIfNeeded
};



// WEBPACK FOOTER //
// ./App/services/userActivity.js